








import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({ name: 'CampusSelect' })
export default class CampusSelect extends Vue {
  private campusOptions: any[] = [
    { label: '广州校区南校园', value: '广州校区南校园', key: '1' },
    { label: '广州校区北校园', value: '广州校区北校园', key: '2' },
    { label: '珠海校区', value: '珠海校区', key: '3' },
    { label: '广州校区东校园', value: '广州校区东校园', key: '4' },
    { label: '深圳校区', value: '深圳校区', key: '5' },
    { label: '其他', value: '其他', key: '-1' },
  ];

  /** 禁用 */
  @Prop({ default: false })
  private disabled: boolean;

  /** 提示占位符 */
  @Prop({ default: '校区' })
  private placeholder: string;

  /** 宽度 */
  @Prop({ default: '160px' })
  private width: string;

  /** 值 */
  @Prop()
  private value: string;

  /** 获取值 */
  get currentValue(): string {
    return this.value;
  }

  /** 返回值 */
  set currentValue(value: string) {
    this.$emit('input', value);
  }
}
